
import { defineComponent, onMounted, reactive } from "vue";
import { useRoute } from "vue-router";
import { IngredienteReceita } from "@/api/interfacesReceita";
import ApiReceita from "@/api/apiReceita";
import toast from "@/core/toast";
import TabelaIngredientes from "./TabelaIngredientes.vue";

export default defineComponent({
  components: { TabelaIngredientes },
  Name: "Receitas",
  setup() {
    const route = useRoute();

    interface Receita {
      receita: IngredienteReceita;
    }

    const state = reactive({
      receita: {} as IngredienteReceita
    }) as Receita;

    async function GetReceita() {
      const request = new ApiReceita();
      const id = parseInt(route.params.id.toString());
      if (id > 0) {
        await request
          .getReceita(id)
          .then(response => {
            state.receita = response;
          })
          .catch(err => {
            toast.error(err, "Ops");
          });
      }
    }

    onMounted(() => {
      GetReceita();
    });

    return { state };
  }
});
